export default __webpack_public_path__ + "static/media/bq.66ea2e65.svg";